const COPPER_ACTION_TYPES = {
  LOAD_COPPER: 'copper/LOAD_COPPER',
};

export default COPPER_ACTION_TYPES;
